// Imperative bridge to the toast / confirm UI.
//
// Lets any module trigger a toast or a confirm dialog without calling the
// useToast() hook, so notifications look identical everywhere (top-right toasts
// and a styled confirm modal) instead of native browser alert()/confirm().
//
// ToastProvider registers the real handlers on mount via registerToastHandlers.

let handlers = {
  push: null,
  confirm: null,
};

export const registerToastHandlers = (h) => {
  handlers = h;
};

export const toast = {
  success: (message, opts) => handlers.push?.(message, { ...opts, type: "success" }),
  error: (message, opts) => handlers.push?.(message, { ...opts, type: "error" }),
  info: (message, opts) => handlers.push?.(message, { ...opts, type: "info" }),
};

// Returns Promise<boolean>. Falls back to the native confirm only if the
// provider isn't mounted (should not happen inside the app tree).
export const confirmDialog = (message, opts) =>
  handlers.confirm
    ? handlers.confirm(message, opts)
    : Promise.resolve(window.confirm(message));
